/**
 * Traduce el contenido del popup nativo de "Back in Stock" de Klaviyo según el
 * idioma de la página. Klaviyo solo permite configurar un único texto (en inglés)
 * para todo el store, así que este script reescribe los nodos de texto exactos
 * una vez Klaviyo inyecta su modal en el DOM.
 *
 * El texto en inglés usado como clave debe coincidir EXACTAMENTE (incluidas
 * erratas) con lo configurado en Klaviyo > Website > Back in Stock.
 */
(function () {
  var locale = (document.documentElement.lang || "en").toLowerCase();

  // 'en' es el idioma por defecto configurado directamente en Klaviyo: nada que traducir.
  if (locale === "en") return;

  var dictionaries = {
    es: {
      "Notify when Back in Stock": "Avísame cuando esté disponible",
      "Notify me when back in stock": "AVÍSAME CUANDO ESTÉ DISPONIBLE",
      "We will notify you when this product back in stock.":
        "Te avisaremos cuando este producto vuelva a estar disponible.",
      "Enter your email address": "Introduce tu correo electrónico",
      "Also receive promotional marketing emails.":
        "Recibir también emails promocionales.",
      "Notify Me!": "Avísame cuando esté disponible",
      "We don't share your information with others.":
        "No compartimos tu información con otros.",
      "All set!": "¡Todo listo!",
      "We’ll let you know as soon as the product is back in stock.":
        "Te avisaremos en cuanto el producto vuelva a estar disponible.",
      "Continue shopping": "Seguir comprando",
    },
    fr: {
      "Notify when Back in Stock": "Prévenez-moi quand disponible",
      "Notify me when back in stock": "PRÉVENEZ-MOI QUAND DISPONIBLE",
      "We will notify you when this product back in stock.":
        "Nous vous préviendrons dès que ce produit sera de nouveau disponible.",
      "Enter your email address": "Entrez votre adresse e-mail",
      "Also receive promotional marketing emails.":
        "Recevoir également des e-mails promotionnels.",
      "Notify Me!": "Prévenez-moi quand disponible",
      "We don't share your information with others.":
        "Nous ne partageons pas vos informations avec d'autres.",
      "All set!": "Tout est prêt !",
      "We’ll let you know as soon as the product is back in stock.":
        "Nous vous informerons dès que le produit sera de nouveau en stock.",
      "Continue shopping": "Continuer vos achats",
    },
    ko: {
      "Notify when Back in Stock": "재입고 시 알림 받기",
      "Notify me when back in stock": "재입고 시 알림 받기",
      "We will notify you when this product back in stock.":
        "이 상품이 재입고되면 알려드리겠습니다.",
      "Enter your email address": "이메일 주소를 입력하세요",
      "Also receive promotional marketing emails.":
        "프로모션 마케팅 이메일도 받기",
      "Notify Me!": "재입고 시 알림 받기",
      "We don't share your information with others.":
        "귀하의 정보를 다른 사람과 공유하지 않습니다.",
      "All set!": "모두 설정되었습니다!",
      "We’ll let you know as soon as the product is back in stock.":
        "상품이 재입고되면 바로 알려드리겠습니다.",
      "Continue shopping": "쇼핑 계속하기",
    },
    ja: {
      "Notify when Back in Stock": "再入荷したら通知する",
      "Notify me when back in stock": "再入荷したら通知する",
      "We will notify you when this product back in stock.":
        "この商品が再入荷した際にお知らせします。",
      "Enter your email address": "メールアドレスを入力してください",
      "Also receive promotional marketing emails.":
        "プロモーションメールも受け取る",
      "Notify Me!": "再入荷したら通知する",
      "We don't share your information with others.":
        "お客様の情報を他者と共有することはありません。",
      "All set!": "すべて設定完了！",
      "We’ll let you know as soon as the product is back in stock.":
        "商品が再入荷次第お知らせします。",
      "Continue shopping": "ショッピングを続ける",
    },
    "zh-cn": {
      "Notify when Back in Stock": "补货时通知我",
      "Notify me when back in stock": "补货时通知我",
      "We will notify you when this product back in stock.":
        "该商品补货后我们会通知您。",
      "Enter your email address": "请输入您的电子邮箱",
      "Also receive promotional marketing emails.": "同时接收促销营销邮件",
      "Notify Me!": "补货时通知我",
      "We don't share your information with others.":
        "我们不会与他人共享您的信息。",
      "All set!": "一切就绪！",
      "We’ll let you know as soon as the product is back in stock.":
        "该商品补货后我们会通知您。",
      "Continue shopping": "继续购物",
    },
  };

  var dict = dictionaries[locale];
  if (!dict) return;

  // Búsqueda insensible a mayúsculas/minúsculas: muchos botones usan
  // text-transform:uppercase en CSS mientras el texto real en el DOM está en
  // minúsculas/normal, así que comparar tal cual fallaría.
  var dictLower = {};
  Object.keys(dict).forEach(function (key) {
    dictLower[key.toLowerCase()] = dict[key];
  });

  function lookup(text) {
    if (dict[text] !== undefined) return dict[text];
    return dictLower[text.toLowerCase()];
  }

  function normalize(text) {
    return text.replace(/\s+/g, " ").trim();
  }

  // Nodos de texto "hoja" sueltos (ej. el texto de un <label> que envuelve un <input>).
  function translateTextNode(node) {
    var text = normalize(node.nodeValue);
    var translated = text && lookup(text);
    if (translated) {
      node.nodeValue = translated;
    }
  }

  // Frases repartidas en varios nodos/elementos internos (título, párrafo con
  // saltos de línea o spans de formato): se compara el texto agregado del
  // contenedor completo y, si coincide, se sustituye entero. Se excluyen
  // contenedores con controles de formulario para no destruir el checkbox/input.
  function translateContainer(el) {
    if (
      el.querySelector &&
      el.querySelector("input, button, select, textarea")
    ) {
      return;
    }
    var text = normalize(el.textContent || "");
    var translated = text && lookup(text);
    if (translated) {
      el.textContent = translated;
    }
  }

  function translateAttributesOn(el) {
    if (el.hasAttribute && el.hasAttribute("placeholder")) {
      var placeholder = el.getAttribute("placeholder");
      var translatedPlaceholder = placeholder && lookup(placeholder);
      if (translatedPlaceholder)
        el.setAttribute("placeholder", translatedPlaceholder);
    }
    if ("value" in el && el.value) {
      var translatedValue = lookup(el.value);
      if (
        translatedValue &&
        el.tagName === "INPUT" &&
        (el.type === "submit" || el.type === "button")
      ) {
        el.value = translatedValue;
      }
    }
  }

  function translateSubtree(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE) return;

    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      null,
      false,
    );
    var textNode;
    while ((textNode = walker.nextNode())) {
      translateTextNode(textNode);
    }

    translateContainer(root);
    if (root.querySelectorAll) {
      root.querySelectorAll("*").forEach(translateContainer);
      root
        .querySelectorAll(
          "input[placeholder], input[type='submit'], input[type='button']",
        )
        .forEach(translateAttributesOn);
    }
    translateAttributesOn(root);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach(translateSubtree);
      } else if (mutation.type === "attributes" && mutation.target) {
        translateAttributesOn(mutation.target);
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["placeholder", "value"],
  });

  // Por si el modal ya existe en el DOM (oculto) antes de que este script se
  // ejecute, hacemos también una pasada inicial.
  translateSubtree(document.body);
})();
